/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddPrintersRequestPrintersInner } from './AddPrintersRequestPrintersInner';
import {
    AddPrintersRequestPrintersInnerFromJSON,
    AddPrintersRequestPrintersInnerFromJSONTyped,
    AddPrintersRequestPrintersInnerToJSON,
    AddPrintersRequestPrintersInnerToJSONTyped,
} from './AddPrintersRequestPrintersInner';

/**
 * 
 * @export
 * @interface AddPrintersRequest
 */
export interface AddPrintersRequest {
    /**
     * 
     * @type {Array<AddPrintersRequestPrintersInner>}
     * @memberof AddPrintersRequest
     */
    printers: Array<AddPrintersRequestPrintersInner>;
}

/**
 * Check if a given object implements the AddPrintersRequest interface.
 */
export function instanceOfAddPrintersRequest(value: object): value is AddPrintersRequest {
    if (!('printers' in value) || value['printers'] === undefined) return false;
    return true;
}

export function AddPrintersRequestFromJSON(json: any): AddPrintersRequest {
    return AddPrintersRequestFromJSONTyped(json, false);
}

export function AddPrintersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddPrintersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'printers': ((json['printers'] as Array<any>).map(AddPrintersRequestPrintersInnerFromJSON)),
    };
}

export function AddPrintersRequestToJSON(json: any): AddPrintersRequest {
    return AddPrintersRequestToJSONTyped(json, false);
}

export function AddPrintersRequestToJSONTyped(value?: AddPrintersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'printers': ((value['printers'] as Array<any>).map(AddPrintersRequestPrintersInnerToJSON)),
    };
}

